import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40a1c071"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "abusolute-center bg-white shadow-lg w-full sm:w-max rounded-lg" };
const _hoisted_2 = {
    class: "py-8 px-5 sm:px-12",
    id: "app"
};
const _hoisted_3 = { class: "grid grid-cols-1 gap-6" };
const _hoisted_4 = {
    key: 0,
    class: "block"
};
const _hoisted_5 = { class: "text-gray-700" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_7 = ["type"];
const _hoisted_8 = { class: "block" };
const _hoisted_9 = { class: "text-gray-700" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_11 = { class: "list-disc ml-5" };
const _hoisted_12 = ["type"];
const _hoisted_13 = { class: "block" };
const _hoisted_14 = { class: "text-gray-700" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_16 = { class: "list-disc ml-5" };
const _hoisted_17 = ["type"];
const _hoisted_18 = { class: "flex justify-center mt-12" };
const _hoisted_19 = {
    key: 0,
    class: "block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_ErrMsgCard = _resolveComponent("ErrMsgCard");
    const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Title, {
                msg: "パスワード変更",
                submsg: "Password Change"
            }),
            _createElementVNode("form", {
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.changePassword && _ctx.changePassword(...args)), ["prevent"])),
                class: "text-gray-700"
            }, [
                _createVNode(_component_ErrMsgCard, {
                    errMsgs: $data.errMsgs,
                    process: "パスワード変更"
                }, null, 8, ["errMsgs"]),
                _createElementVNode("div", _hoisted_3, [
                    ($data.isReturn == 1)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString($data.oldPassword.key), 1),
                            _hoisted_6,
                            _withDirectives(_createElementVNode("input", {
                                type: $options.getPassInputType($data.isOldPassVisible),
                                placeholder: "現在のパスワードを入力",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.oldPassword.value) = $event)),
                                maxlength: "16",
                                class: "w-full"
                            }, null, 8, _hoisted_7), [
                                [_vModelDynamic, $data.oldPassword.value]
                            ]),
                            ($data.oldPassword.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "pass-mask-icon",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => ($options.oldPassVisibleToggle && $options.oldPassVisibleToggle(...args)))
                                }, [
                                    ($data.isOldPassVisible)
                                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                            key: 0,
                                            icon: "eye-slash",
                                            size: "lg"
                                        }))
                                        : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                            key: 1,
                                            icon: "eye",
                                            size: "lg"
                                        }))
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString($data.newPassword.key), 1),
                        _hoisted_10,
                        _createElementVNode("ul", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.passwordRuleMsgs, (msg, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: index,
                                    class: "text-sm text-red-500"
                                }, _toDisplayString(msg), 1));
                            }), 128))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                            type: $options.getPassInputType($data.isNewPassVisible),
                            placeholder: "新しいパスワードを入力",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.newPassword.value) = $event)),
                            maxlength: "16",
                            class: "w-full",
                            autocomplete: "new-password"
                        }, null, 8, _hoisted_12), [
                            [_vModelDynamic, $data.newPassword.value]
                        ]),
                        ($data.newPassword.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "pass-mask-icon",
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => ($options.newPassVisibleToggle && $options.newPassVisibleToggle(...args)))
                            }, [
                                ($data.isNewPassVisible)
                                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                        key: 0,
                                        icon: "eye-slash",
                                        size: "lg"
                                    }))
                                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                        key: 1,
                                        icon: "eye",
                                        size: "lg"
                                    }))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString($data.newPasswordConfirm.key), 1),
                        _hoisted_15,
                        _createElementVNode("ul", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.passwordRuleMsgs, (msg, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: index,
                                    class: "text-sm text-red-500"
                                }, _toDisplayString(msg), 1));
                            }), 128))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                            type: $options.getPassInputType($data.isNewPassConfirmVisible),
                            placeholder: "再度新しいパスワードを入力",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($data.newPasswordConfirm.value) = $event)),
                            maxlength: "16",
                            class: "w-full",
                            autocomplete: "new-password"
                        }, null, 8, _hoisted_17), [
                            [_vModelDynamic, $data.newPasswordConfirm.value]
                        ]),
                        ($data.newPasswordConfirm.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "pass-mask-icon",
                                onClick: _cache[5] || (_cache[5] =
                                    //@ts-ignore
                                    (...args) => ($options.newPassConfirmVisibleToggle && $options.newPassConfirmVisibleToggle(...args)))
                            }, [
                                ($data.isNewPassConfirmVisible)
                                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                        key: 0,
                                        icon: "eye-slash",
                                        size: "lg"
                                    }))
                                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                        key: 1,
                                        icon: "eye",
                                        size: "lg"
                                    }))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                    ($data.isReturn == 1)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_19, [
                            _createElementVNode("button", {
                                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$router.go(-1))),
                                type: "button",
                                name: "back-button",
                                class: "btn btn-gray w-full mr-5 md:mr-10"
                            }, " 戻る ")
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("button", {
                        onClick: _cache[7] || (_cache[7] =
                            //@ts-ignore
                            (...args) => ($options.update && $options.update(...args))),
                        type: "button",
                        name: "button",
                        class: "btn btn-red w-full"
                    }, " 更新 ")
                ])
            ], 32)
        ])
    ]));
}
